<div *ngIf="consent" class = "consent-wrapper">
    {{content }}
    <button (click) = "handleConsent(false)" mat-button class="cookie-btn">{{'Decline'}}</button>
    <button (click) = "handleConsent(true)" mat-flat-button class = "cookie-btn" style="margin-right: 10px;">{{'Accept'}}</button>
</div>
